import React, { forwardRef } from 'react';

import { classnames } from '@lumapps/classnames';
import { Theme } from '@lumapps/lumx/react';
import { SystemPageReference } from '@lumapps/navigation/types';
import { SYSTEM_PAGES_ROUTES } from '@lumapps/navigation/utils/systemPageUtils';
import { Link as RouterLink } from '@lumapps/router';

export interface SystemPagesLinkProps {
    theme?: Theme;
    systemPageReference: SystemPageReference;
    // Forwarded props.
    [key: string]: any;
}

const CLASSNAME = 'system-pages-link';

export const SystemPagesLink = forwardRef<HTMLAnchorElement, SystemPagesLinkProps>(
    ({ theme, children, className, systemPageReference, ...forwardedProps }, ref) => {
        return (
            <RouterLink
                {...forwardedProps}
                to={SYSTEM_PAGES_ROUTES[systemPageReference]}
                className={classnames(
                    className,
                    CLASSNAME,
                    theme === Theme.dark ? 'lumx-link--color-light' : undefined,
                )}
                ref={ref}
            >
                {children}
            </RouterLink>
        );
    },
);
